import { convertToIsoDateTime } from "../datetime";
import { newOfficer } from "../Officer/officer";
import OfficerAction from "@common/redux/actions/OfficerAction";

const prepareIncidentData = (data, formData, siteGuid) => {
  let record = { ...formData.incidentRecord };

  record.incidentDate = convertToIsoDateTime(data.date, data.time);
  record.id = data.id;
  record.rowVersion = data.rowVersion;
  record.incidentType = formData.incidentType;

  record.customerIncident = {};
  record.customerIncident.customerIncidentType = data.customerIncidentType;

  let newCustomers = [];
  let existingCustomers = [];

  data.customers.forEach((person) => {
    if (person.id) {
      existingCustomers.push(person.id);
    } else {
      const nextPerson = { ...formData.customerRecord, ...person };

      const fields = ["address1", "address2", "postcode", "town"];
      fields.forEach((field) => (nextPerson[field] = ""));

      newCustomers.push(nextPerson);
    }
  });
  record.customerIncident.customers = newCustomers;
  record.customerIncident.customerIds = existingCustomers;

  record.customerIncident.customerIncidentDetails = data.description;

  record.customerIncident.capturedByCctv = data.capturedByCctv;
  record.customerIncident.anyoneInjured = data.injuries;
  if (data.injuries) {
    record.customerIncident.detailsOfInjured = data.injuryDetails;
  }

  const esCalled = data.esCalled;
  record.customerIncident.emergencyServicesCalled = esCalled;

  if (esCalled) {
    record.customerIncident.policeCalled = data.esTypes.includes("police")
      ? true
      : false;
    record.customerIncident.ambulanceCalled = data.esTypes.includes("ambulance")
      ? true
      : false;
    record.customerIncident.fireServiceCalled = data.esTypes.includes("fire")
      ? true
      : false;

    record.customerIncident.timeEmergencyServicesCalled = convertToIsoDateTime(
      data.date,
      data.timeServicesContacted,
    );

    record.customerIncident.emergencyServicesAttended =
      !data.servicesDidNotAttend;
    if (!data.servicesDidNotAttend) {
      record.customerIncident.timeEmergencyServicesArrived =
        convertToIsoDateTime(data.date, data.timeServicesArrived);
    }

    if (data.servicesDidNotAttend) {
      record.customerIncident.incidentNumber = null;
      record.customerIncident.officerId = null;
      record.customerIncident.officer = null;
      record.customerIncident.ambulanceDetails = null;
    } else {
      record.customerIncident.incidentNumber = data.incidentNumber;

      record.customerIncident.officerId =
        data.esTypes.includes("police") && data.officer.id
          ? data.officer.id
          : null;

      if (!data.esTypes.includes("police") || data.officer.id) {
        record.customerIncident.officer = null;
      } else {
        const { policeId } = OfficerAction.data();
        const officer = newOfficer(data.officer, policeId);
        let officerRecord = { ...formData.officerRecord, ...officer };
        officerRecord.RowVersion = "";

        record.customerIncident.officer = officerRecord;
      }

      if (data.esTypes.includes("ambulance")) {
        record.customerIncident.ambulanceDetails = data.ambulanceDetails;
      }
    }
  }

  record.customerIncident.comments = data.comments;

  record.site = { ...record.site, guid: siteGuid }; // prevents state mutation

  record.enforcementVisit = null;
  record.gamblingDispute = null;
  record.suspiciousActivity = null;

  return record;
};

export default prepareIncidentData;
